var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.6456V19.3975C11.25 18.963 11.4756 18.5596 11.8459 18.3323L14.3459 16.7972C14.7472 16.5508 15.2528 16.5508 15.6541 16.7972L18.1541 18.3323C18.5244 18.5596 18.75 18.963 18.75 19.3975V22.6456M6.01925 12.8126L12.2618 6.17988C13.7424 4.60671 16.2427 4.6067 17.7233 6.17988L23.9742 12.8214C24.6284 13.5165 24.9929 14.4348 24.9934 15.3893L24.9979 22.8705C24.9991 24.8516 23.4591 26.4919 21.4818 26.6154L15 27.0205L8.51608 26.6153C6.5397 26.4918 5 24.8528 5 22.8726V15.3827C5 14.4275 5.36455 13.5082 6.01925 12.8126Z",
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9ef4087924eb8ba80fa2e65814ca5a74.svg";
export { ForwardRef as ReactComponent };